import { isLandingJourneyId } from '@web-store-platforms/utils';

export { LANDING_JOURNEY_HEADER, isLandingJourneyId } from '@web-store-platforms/utils';

export const LANDING_JOURNEY_COOKIE = 'ac_portal_journey';

export const createPortalLandingJourneyId = (): string => crypto.randomUUID();

export const readLandingJourneyId = (): string | undefined => readLandingJourneyIdFromCookie();

export const readLandingJourneyIdFromCookie = (): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const match = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${LANDING_JOURNEY_COOKIE}=`));
  if (!match) {
    return undefined;
  }

  const value = decodeURIComponent(match.slice(`${LANDING_JOURNEY_COOKIE}=`.length));
  return isLandingJourneyId(value) ? value : undefined;
};
